import {
  showUploadProgress,
  setUploadProgressCurrent,
  setUploadProgressTotal,
} from './UI/state/actions';

/**
 * Return function used on axios `onUploadProgress` callback
 *
 * @param {*} dispatch
 */
export const generateFileProgressEvent = dispatch => {
  let setTotal = false;

  return progressEvent => {
    if (!setTotal) {
      dispatch(showUploadProgress());
      dispatch(setUploadProgressTotal(progressEvent.total));
      setTotal = true;
    }

    dispatch(setUploadProgressCurrent(progressEvent.loaded));
  };
};



// WEBPACK FOOTER //
// ./src/common/FileProgress.js